<template>
  <!-- SECTION Logs-->
  <div v-if="displayLogParamsRaw != ''"
  style="display:flex; position: absolute; top: 0; left: 0; width: 100vw; height: 100%; padding-left: 7rem; z-index: 9; background-color: #00000080; overflow: none; align-items: center"
  @click.self="displayLogParamsRaw = ''">
    <div class="m-5 p-3 rounded-5 bg-white w-100 h-75 overflow-auto">
      <VueJsonPretty
        :data="displayLogParamsRaw"
        :deep="3"
        showLength
      />
    </div>
  </div>

  <div id="logsSection" class="row col-12 m-0 p-0">
    <div class="row col-12 p-2 mt-0 m-0 section-container justify-content-center"  style="height: calc(100vh - 5px);">
      <div class="col-12 m-0 overflow-hidden justify-content-center bg-black rounded-5 p-0">
        <div class="row col-12 table-responsive m-0 p-0 pb-3">
          <div class="position-sticky col-12 m-0 pt-2 pb-2 bg-black text-white">
            <div class="row p-0 m-0">
              <!--Primera sección-->
              <div class="row col-6 m-0 pt-0 ps-3 pe-4 text-white rounded-5 rounded-end" >
              </div>
              <!-- Fin Primera sección-->
              <div class="row col-6 justify-content-end p-0 m-0 pe-3">
                 
                <div class="row col-md-3 col-8 justify-content-end">
                  <span class="text-end text-white mt-1 mb-2 pe-4">
                    <ion-icon name="people-outline" class="tx-16 mb-1 me-1 align-bottom"></ion-icon>
                    {{ dictionary["Logs"][session.user.language] }}
                  </span>
                </div>

              </div>

            </div>
          </div>
        </div>
        
        <div class="row col-12 p-0 ps-4 mt-0 h-auto text-white table-responsive overflow-visible overflow-visible">

          <div class="row col-12 d-flex m-0 p-0 ps-2 ms-1">
            <div class="col-4 m-0 p-0 pe-3">
              <label class="col-12 m-0 p-0 pb-1 tx-16">
                {{ dictionary['Fecha inicio'][session.user.language] }}:
              </label>
              <input v-model="formattedStartDateTime" id="inputCreateStartDate"
                class="dateInput form-control tx-10 rounded text-nowrap mb-2"
                type="datetime-local" @change="handleCreateStartDateTimeChange($event)">
            </div>
            <div class="col-4 m-0 p-0 pe-3">
              <label class="col-12 m-0 p-0 pb-1 tx-16">
                {{ dictionary['Fecha fin'][session.user.language] }}:
              </label>
              <input v-model="formattedEndDateTime" id="inputCreateEndDate"
                class="dateInput form-control tx-10 rounded text-nowrap mb-2"
                type="datetime-local" @change="handleCreateEndDateTimeChange($event)">
            </div>
            <div class="col-3 m-0 p-0 pe-3">
              <label class="col-12 m-0 p-0 pb-1 tx-16">
                {{ dictionary['Tipo'][session.user.language] }}:
              </label>
              <select v-model="targetActionType"
                class="dateInput form-control tx-10 rounded text-nowrap mb-2"
                style="height: 2.1rem;">
                <option key="showAll" value="showAll">
                  {{ dictionary['Mostrar todo'][session.user.language] }}
                </option>
                <option v-for="type of actionTypeList" :key="type.accion" :value="type.accion">
                  {{ type.descripcion }}
                </option>
              </select>
            </div>
            <div class="col-1 m-0 p-0 d-flex p-0 pb-2" style="align-content: bottom;">
              <span class="d-flex bg-clomos justify-content-center align-items-center rounded-3 mb-0 mt-auto" style="width: 2rem; height: 2rem;">
                <ion-icon @click="onRefresh()" class="c-pointer text-white tx-28 rounded"
                  name="refresh-outline"></ion-icon>
              </span>
            </div>
          </div>

          <table id="logsDataTable" class="table m-0 p-0 pb-3 bg-black text-white overflow-auto rounded-5 border-1 p-2 table-responsive">
            
            <thead class="bg-lat1 tx-14 text-white text-center overflow-hidden">
              <tr>
                <th v-for="column in logsColumns" :key="column.data" :width="column.width"
                  class="fw-medium text-nowrap p-2">
                  {{ dictionary[column.text][session.user.language] }}
                </th>
              </tr>
            </thead>
          </table>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import $ from 'jquery';
// Clomos
import api from '@/services/api';
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
//assets
import availableModulesJSON from '@/assets/json/rol_name_types'

export default {
  name: "LogsComponent",
  components: {VueJsonPretty},
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
    availableCompanies: {
      type: Object,
      required: true,
    },
    visibility: {
      type: Object,
      required: true,
    },
    dataTableOptions: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      availableModules: availableModulesJSON,
      userRol: [],
      logsColumns: [
        { text: "Usuario", data: "logUser", width: "20%", className: "tx-left align-middle" },
        { text: "Fecha", data: "logDateTime", width: "20%", className: "tx-left align-middle",
          render: (data) => {
            return (data != "")
              ? "<span style='display: none;'>" + data.getTime() + "</span> <spam>" + api.parseDateUserTimezone(data, this.session.user, this.$dayjs) + "</spam>"
              : "<span style='display: none;'></span> <spam>-</spam>";
          }
        },
        { text: "Tipo", data: "logAction", width: "10%", className: "tx-left align-middle" },
        {
          text: "Parámetros",
          data: "logParams",
          width: "40%",
          className: "tx-left align-middle",
          render: (data) => {
            if (!data) return "-";
            const shortText =
              data.length > 100
                ? data.slice(0, 100) + "..."
                : data;
            return shortText;
          }
        },
        { text: "Copiar", data: "logParams", width: "5%", className: "tx-left align-middle", 
          render: (data) => {
            return "<ion-icon name='copy-outline' data='"+data+"'' class='btnCopyLog btn tx-18 tx-clomos-midtone'></ion-icon>"
          }
        },
        { text: "Mostrar", data: "logParams", width: "5%", className: "tx-left align-middle",
          render: (data) => {
            return "<ion-icon name='eye-outline' data='"+data+"' class='btnDisplayLogParams tn tx-18 tx-clomos-midtone'></ion-icon>"
          }
        }
      ],
      targetLogId: this.$route.params.targetEntity,
      logList: [],
      actionTypeList: [],
      targetActionType: "showAll",
      createStartDateTimeInput: api.parseDateTimeToString(new Date().setDate(new Date().getDate() - 1)),
      createEndDateTimeInput: api.parseDateTimeToString(new Date()),
      formattedStartDateTime: "",
      formattedEndDateTime: "",
      displayLogParamsRaw: ""
    }
  },
  methods: {
    async exportCSVWithDialog(dataTable) {
      try {
        const exportData = typeof dataTable?.buttons?.exportData === 'function'
          ? dataTable.buttons.exportData({
              columns: ':visible',
              modifier: {
                search: 'applied',
                order: 'applied'
              }
            })
          : null;
        const headers = Array.isArray(exportData?.header) ? exportData.header : [];
        const rows = Array.isArray(exportData?.body) ? exportData.body : [];
        const csvContent = this.generateCSVContent(rows, headers);
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const fileName = `${this.currentCompany?.name || 'export'}_data_${timestamp}.csv`;

        if ('showSaveFilePicker' in window && window.isSecureContext) {
          try {
            const fileData = "﻿" + csvContent;
            const fileHandle = await window.showSaveFilePicker({
              suggestedName: fileName,
              types: [{
                description: 'CSV File',
                accept: { 'text/csv': ['.csv'] }
              }]
            });
            const writable = await fileHandle.createWritable();
            await writable.write(fileData);
            await writable.close();
            return;
          } catch (error) {
            if (error.name !== 'AbortError') {
              console.error('Error con showSaveFilePicker:', error);
            }
            if (error.name === 'AbortError') return;
          }
        }

        this.fallbackDownloadCSV(csvContent, fileName);
      } catch (error) {
        console.error('Error exportando CSV:', error);
      }
    },
    generateCSVContent(data, columns) {
      const separator = this.session?.user?.fieldSeparator || ';';
      const headers = (columns || []).map((column) => this.escapeCSVField(this.getCSVHeaderLabel(column)));
      let csvContent = headers.join(separator) + '\n';

      for (let i = 0; i < data.length; i++) {
        const row = Array.isArray(data[i]) ? data[i] : [data[i]];
        const rowData = row.map((field) => this.escapeCSVField(this.extractValueFromRow(field)));
        csvContent += rowData.join(separator) + '\n';
      }

      return csvContent;
    },
    getCSVHeaderLabel(column) {
      const headerText = (column === null || column === undefined ? '' : String(column)).replace(/\s+/g, ' ').trim();
      return this.dictionary?.[headerText]?.[this.session?.user?.language] || headerText;
    },
    extractValueFromRow(field) {
      if (field === null || field === undefined) return '';
      if (typeof field === 'string') {
        const container = document.createElement('div');
        container.innerHTML = field;
        return (container.textContent || container.innerText || '').replace(/\s+/g, ' ').trim();
      }
      if (typeof field === 'number' || typeof field === 'boolean') return String(field);
      if (Array.isArray(field)) return field.map((item) => this.extractValueFromRow(item)).join(', ');
      if (typeof field === 'object') return JSON.stringify(field);
      return String(field);
    },
    escapeCSVField(field) {
      const normalizedField = field === null || field === undefined ? '' : String(field);
      if (
        normalizedField.includes('"') ||
        normalizedField.includes(';') ||
        normalizedField.includes(',') ||
        normalizedField.includes('\n') ||
        normalizedField.includes('\r')
      ) {
        return `"${normalizedField.replace(/"/g, '""')}"`;
      }
      return normalizedField;
    },
    fallbackDownloadCSV(csvContent, fileName) {
      const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    // DATES
    handleCreateStartDateTimeChange(event) {
      const value = event.target.value;
      if (value) {
        this.createStartDateTimeInput = value;
        this.formattedStartDateTime = value;
      }
    },
    handleCreateEndDateTimeChange(event) {
      const value = event.target.value;
      if (value) {
        this.createEndDateTimeInput = value;
        this.formattedEndDateTime = value;
      }
    },
    formatDateTimeForInput(dateString) {
      if (!dateString) return '';
      const normalizedNaiveDateTime = this.normalizeNaiveDateTimeString(dateString);
      if (normalizedNaiveDateTime) {
        return normalizedNaiveDateTime.replace(" ", "T").slice(0, 16);
      }
      const date = this.$dayjs(dateString).utc();
      const userTimeZone = this.session.user.dateTimeZone;
      const formattedDate = date.tz(userTimeZone).format("YYYY-MM-DDTHH:mm");
      return formattedDate;
    },
    normalizeNaiveDateTimeString(dateValue) {
      if (!dateValue) return "";
      const normalized = String(dateValue).trim().replace(/\+/g, " ").replace("T", " ");
      const naiveDateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/;
      if (!naiveDateTimePattern.test(normalized)) {
        return "";
      }
      return normalized.length === 16 ? `${normalized}:00` : normalized;
    },
    // DISPLAY
    displayLogsDataTable() {
      $("#logsDataTable").DataTable().clear()
      for (let i in this.logList) {
        let actionName = this.logList[i].accion;
        for (let ii in this.actionTypeList) {
          if (this.actionTypeList[ii].accion == this.logList[i].accion) actionName = this.actionTypeList[ii].descripcion;
        }
        $("#logsDataTable").DataTable().rows.add([{
          logUser: this.logList[i].identificadorUsuario,
          logAction: actionName,
          logParams: this.logList[i].parametros,
          logDateTime: new Date(this.logList[i].fecha)
        }]);
      }
      $("#logsDataTable").DataTable().draw();
      $("#logsDataTable").DataTable().page.len(15).draw(false);

      this.setButtonFunctions();
      if ($(".dataTables_paginate").get()[0] != undefined) $(".dataTables_paginate").get()[0].addEventListener('click', this.setButtonFunctions);
      $(".sorting").get().forEach((btn) => { btn.addEventListener('click', this.setButtonFunctions) });
    },
    async displayRolbyModulues() {
      this.userRol = [];
      let userModules = this.session.authorisation.availableModules;
      for (let moduleName in userModules) {
        for (let moduleRol in this.availableModules[moduleName]) {
          let rolInfo = {
            numero: moduleRol,
            nombre: this.availableModules[moduleName][moduleRol]
          };
          let existingRolIndex = this.userRol.findIndex(addedRol => addedRol.numero === rolInfo.numero);
          if (existingRolIndex !== -1) {
            if (!this.userRol[existingRolIndex].nombre.includes(rolInfo.nombre)) {
              this.userRol[existingRolIndex].nombre += "/" + rolInfo.nombre;
            }
          } else {
            this.userRol.push(rolInfo);
          }
        }
      }
    },
    // BUTTONS
    setButtonFunctions() {
      setTimeout(() => {
        $(".btnCopyLog").get().forEach(btn => {
          btn.addEventListener('click', this.onCopyLog);
        });
        $(".btnDisplayLogParams").get().forEach(btn => {
          btn.addEventListener('click', this.onDisplayLogParams);
        });
      }, 300);
    },
    onCopyLog(event) {
      if (navigator?.clipboard?.writeText != undefined) {
        navigator?.clipboard?.writeText(event.target.getAttribute('data'));
      }
      else if (document.execCommand != undefined) {
        var textarea = document.createElement("textarea");
        textarea.value = event.target.getAttribute('data');
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea); 
      }
    },
    onDisplayLogParams(event) {
      this.displayLogParamsRaw = JSON.parse(event.target.getAttribute('data'));
    },
    // GET
    async getLogs(callback) {
      this.logList = [];
      let logsResponse = await api.getSystemLogs(this.targetActionType, this.formattedStartDateTime, this.formattedEndDateTime);
      if (logsResponse["status-code"] == "200") {
        this.logList = logsResponse["logs"].reverse();
      }
      if (callback && typeof callback === "function") callback(this.logList);
    },
    async getLogTypes() {
      let typesResponse = await api.getActionTypeList();
      if (typesResponse["status-code"] == "200") {
        this.actionTypeList = typesResponse["tiposAcciones"];
      }
    },
    async onRefresh() {
      await this.getLogs();
      this.displayLogsDataTable();
    }
  },
  async created() {
    this.formattedStartDateTime = this.formatDateTimeForInput(this.createStartDateTimeInput);
    this.formattedEndDateTime = this.formatDateTimeForInput(this.createEndDateTimeInput);
    this.targetActionType = "showAll";
    await this.getLogs();
    await this.getLogTypes();
    this.displayLogsDataTable();

  },
  async mounted() {
    this.displayRolbyModulues()
    $("#logsDataTable").DataTable(
      {
        pagingType: 'full_numbers',
        pageLength: 30,
        processing: true,
        dom: 'Bfrtip',
        buttons: [
          { "extend": 'colvis', "className": 'btn' },
          { "extend": 'copy', "className": 'btn' },
          {
            "extend": 'csv',
            "className": 'btn',
            "action": (e, dt) => {
              this.exportCSVWithDialog(dt);
            }
          },
          { "extend": 'print', "className": 'btn me-0' },
        ],
        columns: this.logsColumns,
        select: this.dataTableOptions.select,
        language: this.dataTableOptions.language[this.session.user.language],
        stateSave: this.dataTableOptions.stateSave,
      }
    );
    $(".dataTables_filter").get()[0].getElementsByTagName('input')[0].addEventListener('blur', this.setButtonFunctions);
  }
}
</script>

<style>
.btnCopyLog:hover, .btnDisplayLogParams:hover {
  color: var(--main-dark) !important;
}

.vjs-key {
    color: #1976d2;
    font-weight: 600;
}

.vjs-value-string {
    color: #2e7d32;
}

.vjs-value-number {
    color: #962323;
}

.vjs-value-boolean {
    color: #9c27b0;
}
</style>